// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscription-disclaimer-workflow-step{background-color:#fff;border-radius:10px;color:#000;padding:10px}.subscription-disclaimer-workflow-step .rdw-editor-toolbar{display:none}.subscription-disclaimer-workflow-step .DraftEditor-editorContainer,.subscription-disclaimer-workflow-step .welcome-message{border:none;margin-bottom:1rem}.subscription-disclaimer-workflow-step .btn{width:100%}.subscription-logo{margin-top:1rem}", ""]);
// Exports
module.exports = exports;
